module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e565"
    }
  }, [_vm._v("Copyright © 2006 by Rebecca Pawel ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e655"
    }
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e705"
    }
  }, [_vm._v("Published by"), _c('br'), _vm._v("Soho Press, Inc."), _c('br'), _vm._v("853 Broadway"), _c('br'), _vm._v("New York, NY 10003 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e855"
    }
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e885"
    }
  }, [_vm._v("Pawel, Rebecca, 1977–"), _c('br'), _vm._v("The summer snow / Rebecca Pawel"), _c('br'), _vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e1055"
    }
  }, [_vm._v("ISBN–10: 1-56947-408-7"), _c('br'), _vm._v("ISBN–13: 978-1-56947-408-2"), _c('br'), _vm._v("1. Tejada Alonso y Lâón, Carlos (Fictitious character)—Fiction. 2. Older women—Crimes against—Fiction. 3. Granada (Spain: Province)—Fiction. 4. Aunts—Crimes against—Fiction. 5. Police—Spain—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e1335"
    }
  }, [_vm._v("PS3616.A957S86 2006"), _c('br'), _vm._v("813'.6–dc22        2005051584 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d6e1465"
    }
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0468b040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pawe_9781569477786_epub_c5_r1.vue
// module id = 69
// module chunks = 0